(function () {
  const form = document.getElementById('product-form');
  if (!form) return;
  const variantInput = form.querySelector('[data-form-variant-id]');
  const variantSelect = document.querySelector('[data-variant-select]');

  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      variantInput.value = variantSelect.value;
    });
    // Initial sync in case picker ran first
    variantInput.value = variantSelect.value;
  }

  const submitBtn = form.querySelector('.btn-add-full');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (variantSelect) variantInput.value = variantSelect.value;

    submitBtn.disabled = true;
    const originalLabel = submitBtn.textContent;

    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        submitBtn.textContent = (err.description || 'Could not add to cart').slice(0, 40);
        setTimeout(() => { submitBtn.textContent = originalLabel; submitBtn.disabled = false; }, 2200);
        return;
      }

      // Refresh cart count in header
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });

      submitBtn.textContent = 'Added ✓';
      setTimeout(() => { submitBtn.textContent = originalLabel; submitBtn.disabled = false; }, 1400);
    } catch (err) {
      submitBtn.textContent = 'Network error';
      setTimeout(() => { submitBtn.textContent = originalLabel; submitBtn.disabled = false; }, 2200);
    }
  });
})();
